// extracted by mini-css-extract-plugin
export default {"paymentSection":"C3-z"};